(function() {
    angular
        .module("app")
        .factory("userMessagingService", userMessagingService)

    userMessagingService.$inject = ["$rootScope"]

    function userMessagingService($rootScope) {

        const _service = {}

        const addAlert = (type, alert) => {

            if (type === "success") {

                $rootScope.alertSuccessMessages.push(alert)
                $rootScope.alertSuccess = true

                setTimeout(() => {

                    if ($rootScope.alertSuccessMessages.length > 0) {
                        if ($rootScope.alertSuccessMessages.length === 1) {
                            _service.dismissSuccess()
                        } else {
                            $rootScope.alertSuccessMessages.shift()
                        }
                        $rootScope.$apply()
                    }

                }, 20000)

            } else if (type === "info") {

                $rootScope.alertInfoMessages.push(alert)
                $rootScope.alertInfo = true

            } else {

                $rootScope.alertFailureMessages.push(alert)
                $rootScope.alertFailure = true

                // setTimeout(() => {

                //     if ($rootScope.alertFailureMessages.length > 0) {
                //         if ($rootScope.alertFailureMessages.length === 1) {
                //             _service.dismissFailure()
                //         } else {
                //             $rootScope.alertFailureMessages.shift()
                //         }
                //         $rootScope.$apply()
                //     }

                // }, 40000)

            }
        }
        /**
            $rootScope variables
         **/
        $rootScope.alertFailureMessages  = []
        $rootScope.alertSuccessMessages  = []
        $rootScope.alertInfoMessages = []

        /**
            Show alert failure
            @param error
            @param {boolean} noScroll
         **/
        _service.error = function(error, noScroll) {

            _service.parseAlertMessage(error, "error")

            if (!noScroll) {
                document.body.scrollTop = document.documentElement.scrollTop = 0
            }
        }

        /**
            Show alert info
            @param info
            @param {boolean} noScroll
         **/
        _service.info = function(info, noScroll) {

            _service.parseAlertMessage(info, "info")

            if (!noScroll) {
                document.body.scrollTop = document.documentElement.scrollTop = 0
            }
        }

        /**
            Show alert success
            @param success
            @param {boolean} noScroll
         **/
        _service.success = function(success, noScroll) {

            _service.parseAlertMessage(success, "success")

            if (!noScroll) {
                document.body.scrollTop = document.documentElement.scrollTop = 0
            }
        }

        /**
            Dismiss both alert boxes
         **/
        _service.dismissFailure = function() {
            $rootScope.alertFailure = false
            $rootScope.alertFailureMessages = []
        }

        _service.dismissSuccess = function() {
            $rootScope.alertSuccess = false
            $rootScope.alertSuccessMessages = []
        }

        _service.dismissInfo = function() {
            $rootScope.alertInfo = false
            $rootScope.alertInfoMessages = []
        }

        /**
            Parse alert message
            @param messageData
            @param {string} alertType
         **/
        _service.parseAlertMessage = function(messageData, alertType) {

            if (messageData.hasOwnProperty("data")) {
                return _service.parseAlertMessage(messageData.data, alertType)
            }

            if (messageData.hasOwnProperty("errors")) {

                angular.forEach(messageData.errors, function(value, key) {
                    if (angular.isNumber(key)) {
                        addAlert("failure", value + ".")
                    } else {
                        addAlert("failure", key + " " + value + ".")
                    }
                })

                return

            } else if (messageData.hasOwnProperty("error") && angular.isString(messageData.error)) {

                addAlert("failure", messageData.error)

            }

            if (messageData.hasOwnProperty("role")) {

                angular.forEach(messageData.role, function(value, key) {

                    if (angular.isNumber(key)) {
                        addAlert("failure", value + ".")
                    } else {
                        addAlert("failure", key + " " + value + ".")
                    }
                })

            } else if (angular.isString(messageData)) {

                if (alertType == "error") {
                    addAlert("failure", messageData)
                } else if (alertType == "info") {
                    addAlert("info", messageData)
                } else {
                    addAlert("success", messageData)
                }

            } else if (alertType == "error") {

                addAlert("failure", "An error occurred. Please contact the Wanco support team for assistance.")

            }
        }

        return _service

    }
})()
